module.exports = __webpack_public_path__ + "img/temp-bg-competition.d177c4ea.png";